import { useEffect, useState } from 'react'
import { useMap } from 'ms-map-gl'

export const useCaptureMapThumbnail = () => {
  const { default: map } = useMap()

  const [url, setUrl] = useState<string>()

  useEffect(() => {
    if (map) map.on('idle', idleHandler)

    return () => {
      if (map) map.off('idle', idleHandler)
    }
  }, [map])

  const idleHandler = () => {
    if (!map) return

    const canvas = cloneToCenteredSquareCanvas(map.getCanvas(), 512)
    canvas.toBlob((blob) => {
      if (!blob) throw new Error('Could not convert canvas to blob')

      setUrl(URL.createObjectURL(blob))
    }, 'image/png')
  }

  const cloneToCenteredSquareCanvas = (
    originalCanvas: HTMLCanvasElement,
    dimension: number
  ) => {
    // Create a new canvas element
    const clonedCanvas = document.createElement('canvas')
    clonedCanvas.width = dimension
    clonedCanvas.height = dimension

    // Scale and draw the original canvas content onto the new canvas
    const context = clonedCanvas.getContext('2d')
    if (!context) throw new Error('Could not get 2d context from canvas')

    const oldAspect = originalCanvas.width / originalCanvas.height
    const sWidth = oldAspect > 1 ? originalCanvas.height : originalCanvas.width
    const sHeight = oldAspect > 1 ? originalCanvas.height : originalCanvas.width
    const sx = oldAspect > 1 ? (originalCanvas.width - sWidth) / 2 : 0
    const sy = oldAspect > 1 ? 0 : (originalCanvas.height - sHeight) / 2

    context.drawImage(
      originalCanvas,
      sx,
      sy,
      sWidth,
      sHeight,
      0,
      0,
      dimension,
      dimension
    )

    return clonedCanvas
  }

  return url
}
